import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useSickCertDetail = (id) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["sickCertDetail", tenantVal, id],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientsickcert/get/${id}`
      );

      return response.data;
    },
    enabled: !!id && !!tenantVal,
    meta: { skipGlobalError: true },
  });
};
